import React, { useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Button, toaster } from "evergreen-ui";

// GraphQL query to get signed URLs for S3
export const GET_SIGNED_URL = gql`
  query Misc_getS3SignedUrl($contentType: String!, $purpose: S3SignedUrlPurpose!) {
    misc_getS3SignedUrl(contentType: $contentType, purpose: $purpose) {
      uploadUrl
      url
    }
  }
`;

const DocumentUpload = ({ onUploadComplete }) => {
  const [documents, setDocuments] = useState([]); // Store the selected documents
  const [documentUrls, setDocumentUrls] = useState([]); // Store the final document URLs
  const [isUploading, setIsUploading] = useState(false);

  // Use useLazyQuery to get signed URL when triggered
  const [getSignedUrl] = useLazyQuery(GET_SIGNED_URL);

  // Handle the file input change for multiple documents
  const handleFileChange = async (event) => {
    const files = event.target.files;
    if (!files.length) return;
    
    setDocuments([...files]);
  };

  // Handle the document upload process
  const handleUpload = async () => {
    if (documents.length === 0) return;
    setIsUploading(true);

    const uploadedUrls = [];

    try {
      for (const document of documents) {
        // Request a signed URL for each document
        const { data } = await getSignedUrl({
          variables: {
            contentType: document.type,
            purpose: "communication", // Adjust purpose based on your needs
          },
        });

        const { uploadUrl, url } = data.misc_getS3SignedUrl;

        // Upload document to the signed URL
        await uploadDocumentToS3(document, uploadUrl);

        // Collect the uploaded document URL
        uploadedUrls.push(url);
      }

      // Set the document URLs
      setDocumentUrls(uploadedUrls);

      // Pass the array of uploaded URLs to the parent component
      if (onUploadComplete) {
        onUploadComplete(uploadedUrls);
      }

      toaster.success("Documents uploaded successfully.");
    } catch (error) {
      toaster.danger(`Error uploading documents: ${error}`);
    } finally {
      setIsUploading(false);
    }
  };

  // Function to upload document to S3 using the signed URL
  const uploadDocumentToS3 = async (document, uploadUrl) => {
    try {
      await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": document.type, // Set appropriate MIME type for documents (e.g., application/pdf, application/msword)
        },
        body: document, // Upload the raw binary document data
      });
    } catch (error) {
      toaster.danger(`Error uploading document: ${error}`);
    }
  };

  return (
    <div>
      <input type="file" multiple onChange={handleFileChange} />

      {isUploading && <p>Uploading documents...</p>}
      {( documentUrls.length === 0) &&
        <div className="row">
          <div className="col s12">
            <Button className="bt" disabled={isUploading || documents.length === 0} onClick={handleUpload}>
              Upload Documents
            </Button>
          </div>
        </div>
      }
     
      {documentUrls.length > 0 && (
        <div>
          
          <ul>
            {documentUrls.map((url, index) => (
                <li key={index}>
                  
                  <span>
                    {index + 1}.
                    
                    <small style={{
                      paddingTop:"10px"
                    }}> 
                      Document uploaded
                    </small>
                    <i className="material-icons green-text " style={{
                      fontSize:"12px"
                    }}>check_circle_outline</i> 
                  </span>
                  <br/>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    <small>
                      Click to view  
                    </small>
                  </a>
                </li>
                
                )
              )
            }
          </ul>
        </div>
      )}

    </div>
  );
};

export default DocumentUpload;
